export const STEP_INPUTS = {
  personal: ["age", "spouse", "funds", "sibling", "legalStatus"],
  education: ["education", "eduInCanada", "spouse"],
  language: ["language", "french", "spouse"],
  work: ["experience", "teer", "occupationInDemand", "spouse", "earnings"],
  connections: ["connection", "jobOffer", "jobOfferDetails"],
  review: null,
};

export function makeShow(inputs) {
  const set = inputs ? new Set(inputs) : null;
  return (key) => !set || set.has(key);
}

export function visibleSteps(steps, show) {
  return steps.filter((s) => {
    const keys = STEP_INPUTS[s.id];
    return !keys || keys.some(show);
  });
}

export function modelLabel(stream) {
  if (stream.scoring_model === "grid") return `Points grid · out of ${stream.max_points}`;
  if (stream.scoring_model === "crs_based") return "Express Entry · ranked by CRS";
  return "Eligibility-based · no ranking score";
}
